import React from "react";
import PropTypes from "prop-types";
import { Menu, Dropdown } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { DmButton } from "dm-react-ui";
import "./user-menu.css";

export const UserMenu = ({
  name,
  surname,
  email,
  onClickUserAction,
  icon,
  onLogout,
  logoutActionText,
  className,
  alt,
}) => {
  const TextIcon = () => {
    return `${name[0]}${surname[0]}`;
  };

  const menu = (
    <Menu className="user-menu-container">
      <Menu.Item key="user-menu-info-item" className="user-menu-user">
        <div
          style={{
            marginTop: "10px",
            width: "273px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0px 20px 0px 20px",
          }}
        >
          <div>
            <div className="user-menu-user-name">{name}</div>
            <div className="user-menu-user-email">{email}</div>
          </div>
          <DmButton
            onClick={(action) => onClickUserAction(action)}
            style={{ color: "#c2c4cb", borderRadius: 6 }}
            type="icon"
            icon={<EyeOutlined />}
          />
        </div>
      </Menu.Item>
      <Menu.Item
        key="user-menu-logout-item"
        className="user-menu-logout"
        onClick={() => onLogout()}
      >
        {logoutActionText}
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu} placement="bottomRight" className={className}>
      <button
        className="user-menu-ant-dropdown-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-div">
          {icon && <img className="user-menu-user-txt" src={icon} alt={alt} />}
          {!icon && <span className="user-menu-user-txt">{TextIcon()}</span>}
        </div>
      </button>
    </Dropdown>
  );
};

UserMenu.propTypes = {
  name: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  onClickUserAction: PropTypes.func,
  icon: PropTypes.string,
  logoutActionText: PropTypes.string,
  onLogout: PropTypes.func,
  className: PropTypes.string,
};

UserMenu.defaultProps = {
  onClick: () => {},
  onClickUserAction: () => {},
  onLogout: () => {},
};
